import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="add-conditional-form-field"
export default class extends Controller {
  static targets = ['field', 'radio', 'template'];

  static values = {
    code: String
  };

  connect() {
    this.toggleField()
  }

  toggleField(event) {
    if (!this.hasRadioTarget) return;

    let value = null;
    const checked = this.radioTargets.find(r => r.checked);
    value = checked?.value;

    if (this.codeValue.split(',').includes(value) && value !== undefined) {
      if (event) event.preventDefault();
      this.addField();
    } else {
      this.clearField();
    }
  }

  addField() {
    const content = this.templateTarget.innerHTML;
    this.fieldTarget.insertAdjacentHTML('beforeend', content);
  }

  clearField() {
    this.fieldTarget.innerHTML = '';
  }
}
